// Keep the original server row intact during the undo window, including collection links.
export function restoreRemovedItem(rows, item, originalOrder) {
  if (rows.some(row => row.id === item.id)) return rows;
  const position = originalOrder.findIndex(row => row.id === item.id);
  const next = originalOrder.slice(position + 1).map(row => rows.findIndex(current => current.id === row.id)).find(index => index >= 0);
  const restored = [...rows]; restored.splice(next ?? rows.length, 0, item); return restored;
}
export function createPendingRemovals({ schedule = setTimeout, cancel = clearTimeout } = {}) {
  const pending = new Map();
  return {
    has: key => pending.has(key),
    undo(key) {
      const entry = pending.get(key);
      if (!entry || entry.sending) return false;
      cancel(entry.timer); pending.delete(key); entry.restore(); entry.finished?.(); return entry.value || true;
    },
    add(key, { commit, restore, failed, finished, value, delay = 8000 }) {
      if (pending.has(key)) return;
      const entry = { restore, finished, value, sending: false };
      entry.send = async (keepalive = false) => {
        if (entry.sending) return;
        entry.sending = true; cancel(entry.timer);
        try { await commit(keepalive); }
        catch (error) { restore(); failed(error); }
        finally { pending.delete(key); finished?.(); }
      };
      pending.set(key, entry);
      entry.timer = schedule(() => { void entry.send(); }, delay);
    },
    flush() { for (const entry of pending.values()) void entry.send(true); }
  };
}

export const pendingRemovals = createPendingRemovals();
if (typeof window !== 'undefined') window.addEventListener('pagehide', () => pendingRemovals.flush());
